import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=94f66c12&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=ts&"
export * from "./Diff.vue?vue&type=script&lang=ts&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=94f66c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f66c12",
  null
  
)

export default component.exports